export default __webpack_public_path__ + "static/media/bg.e4805710.webp";